import { Component, input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { Fluid } from 'primeng/fluid';
import { CategoryKycConfig } from '@/lib-backend';

/** Reusable, presentation-only editor for a CategoryKycConfig. */
@Component({
    selector: 'app-category-kyc-form',
    standalone: true,
    imports: [FormsModule, Checkbox, Fluid],
    templateUrl: './category-kyc-form.html',
})
export class CategoryKycForm {
    readonly value = model.required<CategoryKycConfig>();
    readonly disabled = input<boolean>(false);

    protected setField<K extends keyof CategoryKycConfig>(field: K, v: CategoryKycConfig[K]): void {
        this.value.update(d => ({ ...d, [field]: v }));
    }
}
